// Cancelling a paid booking refunds 100 % inside the same request (WP-BE-CANCEL-REFUND). The cancel
// response carries `refund` next to `payload`, and only when money was owed back:
//   { payload: <booking>, refund: { ok, reason, refundId, amount } }
// reason is null on ok, else NOT_ONEPAY (paid outside OnePay, nothing was sent), AMOUNT, REJECTED
// or UNANSWERED (BE services/refundGateway.js). An unpaid booking carries no refund at all.
const DEFAULT_TEXT = 'Xác nhận từ chối đặt phòng thành công';

const MANUAL_TEXT = 'Đã huỷ, đơn chờ hoàn thủ công';

const REFUND_REASON_LABELS = {
  REJECTED: 'bị từ chối',
  UNANSWERED: 'không trả lời',
  AMOUNT: 'số tiền không khớp',
};

// The page only cancels from PENDING / MODIFIED / PAID; only a paid one is refunded.
export const CANCEL_UNPAID_TEXT = 'Bạn có chắc chắn muốn hủy đơn đặt phòng này không?';

export const CANCEL_PAID_TEXT = 'Đơn đã thanh toán. Huỷ sẽ hoàn 100% cho khách: tự động qua OnePay '
  + 'nếu khách trả qua OnePay, nếu không đơn chuyển sang Chờ hoàn tiền để hoàn thủ công. Tiếp tục?';

export const getCancelConfirmText = (isPaid) => (isPaid ? CANCEL_PAID_TEXT : CANCEL_UNPAID_TEXT);

// The manual-refund button also serves a booking the place cancelled, which has no bank account of
// the customer, so it no longer lives inside that block; REFUNDED shows it disabled as before.
export const canConfirmManualRefund = (bookingStatus) => (
  ['WAITING_FOR_REFUND', 'REFUNDED'].includes(bookingStatus)
);

export const CANCELLED_BY_LABELS = {
  PLACE: 'chỗ nghỉ / admin',
  USER: 'khách',
};

export const getCancelOutcomeToast = (data = {}) => {
  const { refund } = data;

  if (!refund) return { type: 'success', text: DEFAULT_TEXT };

  if (refund.ok) return { type: 'success', text: 'Đã huỷ và hoàn 100% qua OnePay' };

  // Nothing was sent to OnePay, so there is nothing to warn about: the money goes back by hand.
  if (refund.reason === 'NOT_ONEPAY') return { type: 'success', text: MANUAL_TEXT };

  const reason = REFUND_REASON_LABELS[refund.reason] || refund.reason || 'không rõ lý do';

  return {
    type: 'warning',
    text: `Đã huỷ. OnePay không hoàn được (${reason}), đơn chờ hoàn thủ công`,
  };
};
